import { useState } from "react";

const FORM_ID = "gt-subscribe-form";
const SUBMIT_ADDR = "https://readdy.ai/api/form/dahaqorp14a1h3mr6h70";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);

    const honeypot = String(formData.get("company_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setFeedback("订阅成功，后续有新的进展我们会第一时间通知你。");
      formEl.reset();
      return;
    }

    setStatus("submitting");
    setFeedback("");

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key === "company_alt") return;
        if (typeof value === "string" && value.trim() === "") return;
        params.append(key, value);
      });

      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMessage =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const code = parsed?.code;
      const looksSpam =
        typeof serverMessage === "string" && serverMessage.toLowerCase().includes("spam");

      if (!response.ok || (code && code !== "OK") || looksSpam) {
        setStatus("error");
        setFeedback(
          looksSpam
            ? "系统判定本次提交异常，请稍后重试。"
            : serverMessage || "订阅失败，请稍后再试。",
        );
        return;
      }

      setStatus("success");
      setFeedback("订阅成功，后续有新的进展我们会第一时间通知你。");
      formEl.reset();
    } catch {
      setStatus("error");
      setFeedback("网络好像开小差了，请检查连接后重试。");
    }
  };

  return (
    <form
      id={FORM_ID}
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col gap-2 sm:flex-row">
        <label className="sr-only" htmlFor={`${FORM_ID}-email`}>
          邮箱地址
        </label>
        <input
          id={`${FORM_ID}-email`}
          type="email"
          name="email"
          required
          placeholder="填上你的邮箱，第一时间蹲到后续"
          className="w-full rounded-md border border-primary-600/40 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-accent-400 focus:outline-none"
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "submitting" ? "提交中…" : "订阅蹲后续"}
        </button>
      </div>

      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-guard-field"
      />

      {feedback && (
        <p
          role="status"
          aria-live="polite"
          className={`mt-3 text-sm ${
            status === "error" ? "text-accent-400" : "text-secondary-300"
          }`}
        >
          {feedback}
        </p>
      )}
    </form>
  );
}